const AFFILIATE_SLIDE = {
  selector: ".affiliate-slider",
  config: {
    type: "carousel",
    perView: 5,
    gap: 150,
    animationDuration: 2500,
    autoplay: true,
    bound: true,
    peek: {
      before: 100,
      after: 100,
    },
    breakpoints: {
      330: {
        peek: {
          before: 50,
          after: 50,
        },
      },
      500: {
        perView: 1,
        gap: 0,
      },
      600: {
        perView: 2,
        gap: 0,
      },
      800: {
        perView: 3,
        gap: 40,
      },
    },
  },
};

const TIRE_BRAND_SLIDE = {
  selector: ".tire-brand-slider",
  config: {
    type: "carousel",
    perView: 5,
    gap: 150,
    animationDuration: 2500,
    autoplay: true,
    bound: true,
    peek: {
      before: 100,
      after: 100,
    },
    breakpoints: {
      330: {
        peek: {
          before: 50,
          after: 50,
        },
      },
      500: {
        perView: 1,
        gap: 50,
      },
      600: {
        perView: 2,
        gap: 100,
      },
      800: {
        perView: 3,
        gap: 100,
      },
    },
  },
};

const TESTIMONY_SLIDE = {
  selector: ".testimonial-slider",
  config: {
    type: "carousel",
    perView: 2,
    animationDuration: 1200,
    bound: true,
    peek: {
      before: 0,
      after: 70,
    },
    breakpoints: {
      800: {
        perView: 1,
        peek: {
          before: 0,
          after: 100,
        },
      },
      600: {
        perView: 1,
        peek: {
          before: 0,
          after: 0,
        },
      },
    },
  },
};

export { AFFILIATE_SLIDE, TESTIMONY_SLIDE, TIRE_BRAND_SLIDE };
